<div class="nf-page-header">
	<div class="page-title">
		Notification
	</div>
</div>


<div class="scroll-content">
	<div class="middle-block">
		<div class="date-blocks">
			<div class="date-block" *ngFor="let notificationEntry of (notificationMap$ | async) | keyvalue : returnZero">
				<div class="date-title">
					<span class="date-span">{{notificationEntry.key | date:'MMMM d'}}</span>

					<div class="all-read-button" (click)="markAllAsRead()">
						<span>
							Mark all as read
						</span>
					</div>
				</div>
				<div class="nfs-block">
					<div *ngFor="let notification of notificationEntry.value">

						<app-notification [userNfs]="notification" [fullPage]="true"></app-notification>

					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="footer-block">
		<p-paginator [rows]="limit" [totalRecords]="totalElements$ | async" (onPageChange)="onPageChange($event)"></p-paginator>

	</div>
</div>